var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.454,
    height: 20,
    viewBox: "0 0 19.454 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cog",
    d: "M12,15.5A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5m7.43-2.53A7.77,7.77,0,0,0,19.5,12a8.551,8.551,0,0,0-.07-1l2.11-1.63a.5.5,0,0,0,.12-.64l-2-3.46a.492.492,0,0,0-.61-.22l-2.49,1a7.249,7.249,0,0,0-1.69-.98L14.5,2.42A.506.506,0,0,0,14,2H10a.506.506,0,0,0-.5.42L9.13,5.07a7.249,7.249,0,0,0-1.69.98l-2.49-1a.492.492,0,0,0-.61.22l-2,3.46a.493.493,0,0,0,.12.64L4.57,11a8.551,8.551,0,0,0-.07,1,7.77,7.77,0,0,0,.07.97L2.46,14.63a.493.493,0,0,0-.12.64l2,3.46a.5.5,0,0,0,.61.22l2.49-1.01a6.945,6.945,0,0,0,1.69.99l.37,2.65A.506.506,0,0,0,10,22h4a.506.506,0,0,0,.5-.42l.37-2.65a7.282,7.282,0,0,0,1.69-.99l2.49,1.01a.5.5,0,0,0,.61-.22l2-3.46a.5.5,0,0,0-.12-.64Z",
    transform: "translate(-2.271 -2)",
    fill: "#031f69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSetting);
export default __webpack_public_path__ + "static/media/ico-setting.c2ecbebd034d9c9b25db67b2c8bebd74.svg";
export { ForwardRef as ReactComponent };